import { NoImage } from "@assets/constant/index.constant";

import Tooltip from "@ui/external/components/tooltip";
import { ZoomImage } from "@ui/internal/components/formelement";
import { useHandleAction } from "@utils/hook/index.hook";
import { usePreviewVideo, useSelectionStore } from "@utils/states/index.state";

const ColumnList = () => {
  const { handleAction } = useHandleAction({});
  const { setPreviewVideo } = usePreviewVideo();
  const { clearSelection } = useSelectionStore();

  return [
    {
      name: "ID",

      cell: (row: any) => (
        <span className="font-semibold text-gray-700">{row?.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Thumbnail and Featured Video",
      cell: (row: any) => (
        <div className="flex items-center gap-3">
          <ZoomImage>
            <img
              src={row.thumbnail || NoImage}
              onError={(e: any) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = NoImage;
              }}
              alt="featured"
              className="w-12 h-12 object-cover rounded"
            />
          </ZoomImage>
          {row?.video && (
            <div className="mt-2">
              <video
                src={row?.video}
                onClick={() => setPreviewVideo(row?.video)}
                className="w-12 h-12 object-cover cursor-pointer rounded"
              />
            </div>
          )}
        </div>
      ),
      sortable: false,
    },

    {
      name: "Title",
      cell: (row: any) => (
        <div className="flex justify-start max-w-[200px]">
          <Tooltip description={row.title}>
            <div className="text-lg w-[200px] flex justify-start truncate capitalize font-semibold text-gray-800">
              {row.title}
            </div>
          </Tooltip>
        </div>
      ),
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <div className="flex items-center gap-3  cursor-pointer">
          <button
            className="text-[#1DA077] cursor-pointer"
            onClick={() => handleAction({ type: "modal-edit", data: row.id })}
          >
            Edit
          </button>
          <button
            className="text-[#C33241] cursor-pointer"
            onClick={() => {
              clearSelection();
              handleAction({
                type: "confirm",
                data: { type: "delete", id: row.id },
              });
            }}
          >
            Delete
          </button>
        </div>
      ),
      sortable: false,
    },
  ];
};

export { ColumnList };
